<template>
  <div class="row no-gutters dashboard-container">
    <loading-spinner v-if="isLoading"></loading-spinner>
    <div class="col-12">
        <div class="col-12">
          <div class="helphub-app-container"><router-view :key="$route.path"  ></router-view></div>
        </div>
      </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import LoadingSpinner from "@/components/LoadingSpinner";

export default {
  name: 'SupplierDashboard',
  components: {LoadingSpinner},
  computed: {
    ...mapGetters(["isLoading"]),
  }
};
</script>

<style scoped>
.one-intake-form {
  padding-left: 9.1667%;
  padding-right: 9.1667%;
}

@media (max-width: 768px) {
  .nav-tabs li {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .nav-item {
    width: 100% !important;
  }
}

@media (max-width: 991px) {
  .navbar-tab {
    background-color: #FFFFFF !important;
  }
}

.navbar-tab {
  background-color: #f4f6f8;
}

.nav-tabs,
.nav-link {
  border: none;
  border-radius: 0;
  border: 0 !important;
}
.nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
  border-color: inherit;
}
.nav-tabs li a.active {
  color: #0696d7;
  font-weight: bold;
  border-bottom: 2px #0696d7 solid !important;
}
.navitem-active {
  color: #0696d7 !important;
  font-weight: bold !important;
  border-bottom: 2px #0696d7 solid !important;
}
.nav-tabs {
  border: none;
}
.nav-tabs {
  border: none;
}
.nav-tabs li a {
  min-width: 100px;
  padding-top: 10px;
  text-align: center;
  font-size: 14px;
  color: #000000;
}

.active-tab {
  color: #0696d7 !important;
  font-weight: bold !important;
  background-color: #fff;
  border-bottom-color: transparent !important;
}

.dashboard-container {
  min-height: 900px;
}

</style>